if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('ajax-cart')
        this.submitButton = this.querySelector('[type="submit"]')
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog')

        // product bundle
        this.productBundle = document.querySelector('.product-bundle')

        this.selectedBundleSet = 1
        this.productPersonalizer = document.querySelector('.product-personalizer')

        if (!this.productPersonalizer) {
          document.querySelector('[name="properties[Font size]"]')?.remove()
          document.querySelector('[name="properties[Text Align]"]')?.remove()
        } else {
          // Zepto personalizer

          const observer = new MutationObserver(() => {
            const updateInputValue = (zeptoSelector, inputSelector) => {
              const zeptoInput = document.querySelector(zeptoSelector)
              const input = document.querySelector(inputSelector)

              if (zeptoInput && input) {
                input.value = zeptoInput.value
                zeptoInput.addEventListener('onchange', (event) => {
                  input.value = event.target.value
                })
              }
            }

            updateInputValue('input.pplr-size-select', '[name="properties[Font size]"]')
            updateInputValue('input.pplr-align-select', '[name="properties[Text Align]"]')
          })

          observer.observe(this.productPersonalizer, { childList: true, subtree: true })
          // End Zepto personalizer
        }

        if (this.closest('.product-bar__sticky')) return

        if (!this.closest('.product__info-container')) return

        // set-bundle dropdown
        if (
          !this.closest('.product__info-container').querySelector('[name="amount-bundle"]') &&
          this.closest('.product__info-container').querySelector('#set-bundle-discounts')
        ) {
          return
        }

        this.quantityEl = this.closest('.product__info-container').querySelector('[name="quantity"]')
        this.setBundleEl = this.closest('.product__info-container').querySelectorAll('[name="amount-bundle"]')
        this.setBundleEl.forEach((item) => {
          item.addEventListener('change', this.onSetChange.bind(this))
        })
        this.setBundlePriceEl = this.closest('.product__info-container').querySelector('.set-bundle--price')

        if (this.setBundleEl.length > 0) {
          this.selectedBundleSet = this.setBundleEl[0].value
          const price = this.setBundleEl[0].dataset.price
          // show set bundle price
          this.setBundlePriceEl.innerHTML = ''

          const quantity = this.quantityEl.value
          const setPrice = document.createElement('span')

          setPrice.classList.add('set-price')
          setPrice.textContent = this.formatPrice(this.selectedBundleSet * quantity * price).replace('US', '')
          // this.setBundlePriceEl.appendChild(setPrice);
        }

        const discountObj = this.closest('.product__info-container').querySelector('#set-bundle-discounts')
        if (!discountObj) return
        this.setBundleDiscounts = JSON.parse(discountObj.textContent)
        this.setBundleDiscounts.sort((a, b) => (a['qty-to-buy'] < b['qty-to-buy'] ? 1 : -1))
        const discountRulesEl = this.closest('.product__info-container').querySelector('.set-bundle--discount-rules')
        if (!discountRulesEl) return
        discountRulesEl.innerHTML = this.setBundleDiscounts
          .map((discount, index) => {
            return `<span class="badge badge--sale" style="--order: ${index}">${discount.title}</span>`
          })
          .join('')
      }

      onSetChange(event) {
        const price = event.target.dataset.price
        const compareAtPrice = event.target.dataset.compareAtPrice
        const bundleSet = parseInt(event.target.value) || 1
        
        // Update quantity field to reflect the bundle amount
        if (this.quantityEl) {
          // Check for max limit if it exists
          const maxLimit = this.quantityEl.max ? parseInt(this.quantityEl.max) : null
          const newQuantity = maxLimit && bundleSet > maxLimit ? maxLimit : bundleSet
          
          this.quantityEl.value = newQuantity
          
          // Dispatch change event to notify other listeners
          const changeEvent = new Event('change', { bubbles: true })
          this.quantityEl.dispatchEvent(changeEvent)
        }
        
        // Calculate price based on the updated quantity
        const totalPrice = bundleSet * price
        const totalCompareAtPrice = compareAtPrice != undefined ? bundleSet * compareAtPrice : null
        const setBundleDiscounts = this.setBundleDiscounts
        const setBundlePriceEl = this.setBundlePriceEl
        const setCompareAtPrice = document.createElement('span')
        setCompareAtPrice.classList.add('set-compare-at-price')

        // clear price
        setBundlePriceEl.innerHTML = ''

        // for SALE quantity-bundle
        if (totalCompareAtPrice) {
          setCompareAtPrice.textContent = this.formatPrice(totalCompareAtPrice).replace('US', '')
          setBundlePriceEl.appendChild(setCompareAtPrice)
        }

        // show set bundle price
        const setPrice = document.createElement('span')
        setPrice.classList.add('set-price')
        setPrice.textContent = this.formatPrice(totalPrice).replace('US', '')
        setBundlePriceEl.appendChild(setPrice)

        // check if discounted
        if (!setBundleDiscounts) return
        const theDiscount = setBundleDiscounts.find((discount) => {
          return bundleSet >= discount['qty-to-buy']
        })

        if (!theDiscount) return

        // clear price
        setBundlePriceEl.innerHTML = ''

        // show set bundle discounted price
        setCompareAtPrice.textContent = this.formatPrice(totalPrice).replace('US', '')
        setPrice.textContent = this.formatPrice(totalPrice - totalPrice * (theDiscount.discount / 100)).replace(
          'US',
          ''
        )

        // append discounted price and badge
        setBundlePriceEl.appendChild(setCompareAtPrice)
        setBundlePriceEl.appendChild(setPrice)
      }

      formatPrice(price) {
        if (!price) return
        let formattedPrice = price / 100

        const getLang = () => {
          if (navigator.languages != undefined) return navigator.languages[0]
          return navigator.language
        }

        formattedPrice = formattedPrice.toLocaleString(getLang(), {
          style: 'currency',
          currency: Shopify.currency.active,
        })

        return formattedPrice
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        if (this.querySelector('.loading-overlay__spinner') != null)
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        if (this.cart && this.cart.getSectionsToRender) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }

        if (formData.get('amount-bundle') && this.setBundleEl) {
          const bundleQty = parseInt(formData.get('amount-bundle'))
          const amountBundleEl = this.closest('.product__info-container').querySelector(
            '[name="amount-bundle"]:checked'
          )
          if (!amountBundleEl) return
          const selectedSetText = amountBundleEl.nextElementSibling.textContent.trim()
          // Quantity field already reflects the bundle amount, so use it directly
          formData.append('properties[_qty_bundle_set]', selectedSetText)
          formData.append('properties[_qty_bundle_amount]', bundleQty)
          
          // Check if there's a discount and apply it
          if (this.setBundleDiscounts) {
            const theDiscount = this.setBundleDiscounts.find((discount) => {
              return bundleQty >= discount['qty-to-buy']
            })
            if (theDiscount) {
              formData.append('properties[_bundle_discount]', theDiscount.discount)
              formData.append('properties[_bundle_discount_title]', theDiscount.title)
              console.log('Adding discount to cart:', {
                discount: theDiscount.discount,
                title: theDiscount.title,
                bundleQty: bundleQty
              })
            }
          }
        }

        if (formData.get('selling_plan')) {
          formData.append('properties[_selling_plan]', formData.get('selling_plan'))
        }

        config.body = formData

        // alter the form data if this is a bundle
        let formDataBundle = {}
        if (this.submitButton.hasAttribute('data-is-bundle')) {
          const bundleItems = []
          const bundleQty = parseInt(formData.get('quantity'))
          const bundleKey = this.productBundle.dataset.bundle + '--' + Date.now()

          this.productBundle.querySelectorAll('.product-bundle-item').forEach(function (item) {
            bundleItems.push({
              quantity: bundleQty * item.dataset.qty,
              id: item.dataset.id,
              // "product-id": item.dataset.id,
              properties: {
                _bundle: bundleKey,
                _bundle_qty: item.dataset.qty,
              },
            })
          })

          formDataBundle = {
            items: bundleItems,
          }

          config.headers['Content-Type'] = 'application/json'
          config.body = JSON.stringify(formDataBundle)
        } else if (
          this.submitButton.hasAttribute('data-card-parent-bundle') &&
          this.submitButton.hasAttribute('data-card-bundle')
        ) {
          const bundleItems = []
          const bundleKey = this.submitButton.dataset.cardParentBundle + '--' + Date.now()
          const bundleIds = this.submitButton.dataset.cardBundle.trim().split('|')
          bundleIds.forEach((item) => {
            const eachItem = item.split(':')
            bundleItems.push({
              quantity: eachItem[1],
              id: eachItem[0],
              properties: {
                _bundle: bundleKey,
              },
            })
          })

          formDataBundle = {
            items: bundleItems,
          }

          config.headers['Content-Type'] = 'application/json'
          config.body = JSON.stringify(formDataBundle)
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description)

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButton.querySelector('span').classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            this.error = false
            const quickAddModal = this.closest('quick-add-modal')
            const quickShopModal = document.querySelector('[data-quick-shop-modal]')

            if (quickShopModal) {
              quickShopModal.hide(true)
            }

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (window.cartType === 'p80') {
                      this.cart.toggleCart()
                    } else {
                      this.cart.renderContents(response)
                    }
                  })
                },
                { once: true }
              )
              quickAddModal.hide(true)
            } else {
              if (window.cartType === 'p80') {
                this.cart.toggleCart()
              } else {
                this.cart.renderContents(response)
              }
            }
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (this.cart && this.cart.classList.contains('is-empty') && window.cartType !== 'p80')
              this.cart.classList.remove('is-empty')
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            if (this.querySelector('.loading-overlay__spinner') != null)
              this.querySelector('.loading-overlay__spinner').classList.add('hidden')
          })
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    }
  )
}

/*
 * This is a temporary solution to shorten the linkify links
 * added by p80 Julius - 02062024
 */
function observeProductColors() {
  const observer = new MutationObserver((mutations, obs) => {
    const productColors = document.querySelector('.webyzeProductColors')
    if (productColors) {
      buildCustomLinkify()
      obs.disconnect() // Stop observing once found (optional)
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}

// 2. Only run after DOM is ready
document.addEventListener('DOMContentLoaded', observeProductColors)

function buildCustomLinkify() {
  const productColors = document.querySelector('.webyzeProductColors')
  if (!productColors) return
  const swatches = productColors.querySelectorAll('.swatchProductColor')
  const moreCount = swatches.length > 5 ? swatches.length - 5 : 0
  if (moreCount === 0) return
  const moreButton = document.createElement('button')
  moreButton.type = 'button'
  moreButton.classList.add('more-colors', 'link', 'link--text')
  moreButton.textContent = `+${moreCount} more`

  const lessButton = document.createElement('button')
  lessButton.type = 'button'
  lessButton.classList.add('less-colors', 'link', 'link--text')
  lessButton.textContent = 'less'

  if (productColors.querySelector('button')) return

  productColors.appendChild(moreButton)
  productColors.appendChild(lessButton)

  moreButton.addEventListener('click', function (event) {
    event.target.parentElement.classList.toggle('visible')
  })

  lessButton.addEventListener('click', function (event) {
    event.target.parentElement.classList.toggle('visible')
  })
}
